import { render, staticRenderFns } from "./FSelect.vue?vue&type=template&id=1e64843a&scoped=true"
import script from "./FSelect.vue?vue&type=script&lang=ts"
export * from "./FSelect.vue?vue&type=script&lang=ts"
import style0 from "./FSelect.vue?vue&type=style&index=0&id=1e64843a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e64843a",
  null
  
)

export default component.exports